var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBitcoinLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 61,
    viewBox: "0 0 61 61",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "logos:bitcoin",
    clipPath: "url(#clip0_2832_25194)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M60.0876 37.8757C56.0125 54.2237 39.4493 64.1615 23.1247 60.0861C6.77621 56.0111 -3.16155 39.4486 0.913776 23.1242C4.98886 6.77621 21.528 -3.16155 37.8764 0.913777C54.2011 4.96503 64.1629 21.5275 60.0876 37.8757Z",
    fill: "url(#paint0_linear_2832_25194)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M45.0203 26.6996C45.616 22.6488 42.5422 20.4566 38.3008 19.0031L39.6828 13.4988L36.3469 12.6648L35.0125 18.0262C34.1309 17.8117 33.2254 17.5973 32.3199 17.4066L33.6543 12.0215L30.3184 11.1875L28.9602 16.668C28.2215 16.5012 27.5066 16.3344 26.8156 16.1676V16.1437L22.193 15L21.3113 18.5742C21.3113 18.5742 23.7895 19.1461 23.7418 19.1699C25.1 19.5035 25.3383 20.409 25.2906 21.1238L23.718 27.3906C23.8133 27.4145 23.9324 27.4383 24.0754 27.5098C23.9562 27.4859 23.8371 27.4621 23.718 27.4145L21.5258 36.1832C21.359 36.5883 20.9301 37.2078 20.0008 36.9695C20.0246 37.0172 17.5703 36.3738 17.5703 36.3738L15.9023 40.2102L20.2629 41.3063C21.073 41.5207 21.8594 41.7113 22.6457 41.9258L21.2637 47.4777L24.5996 48.3117L25.9816 42.8074C26.8871 43.0457 27.7926 43.284 28.6504 43.4984L27.2922 48.9789L30.6281 49.8129L32.0102 44.2609C37.7289 45.3332 42.018 44.9043 43.8051 39.7336C45.2586 35.5875 43.7336 33.1809 40.7313 31.6082C42.9473 31.1078 44.5914 29.6543 45.0203 26.6996ZM37.3715 37.4223C36.3469 41.5684 29.3414 39.3285 27.0777 38.7566L28.9125 31.3938C31.1762 31.9656 38.4676 33.0855 37.3715 37.4223ZM38.4199 26.6281C37.4668 30.4168 31.6527 28.4867 29.7703 28.0102L31.4383 21.3383C33.3207 21.8148 39.3969 22.6965 38.4199 26.6281Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2832_25194",
    x1: 3048.35,
    y1: -1.464,
    x2: 3048.35,
    y2: 6099.38,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9AA4B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7931A"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2832_25194"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 61,
    height: 61,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBitcoinLogo);
export default __webpack_public_path__ + "static/media/bitcoin-logo.e3a0b622a2e361465effb09277316a52.svg";
export { ForwardRef as ReactComponent };